export default "__VITE_ASSET__BzbLUwrx__"